import IcSearchOff from './IcSearchOff'

export default IcSearchOff
